
export default function WhyThisWins() {
  const pillars = [
    {
      title: 'Built First. Raising Second.',
      description: 'Infrastructure is operational before capital deployment.'
    },
    {
      title: 'Distribution-Focused Capital.',
      description: 'Funds accelerate customer acquisition — not R&D burn.'
    },
    {
      title: 'Recurring Revenue Engine.',
      description: 'Subscription model with scalable deployment.'
    },
    {
      title: 'Rapid Go-Live Capability.',
      description: '48-hour deployment potential for new clients.'
    }
  ];

  return (
    <section className="py-24 px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Why This <span className="text-[#0EA5E9]">Wins</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] border border-white/10 rounded-2xl p-8 hover:border-[#0EA5E9]/30 transition-all"
            >
              <h3 className="text-xl font-bold mb-3">{pillar.title}</h3>
              <p className="text-gray-300 leading-relaxed">{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
